import { wrapImageOverlayer } from './Overlayer';

export default {
  type: '',
  setup: async ({ app }) => {
    // 注册一个新的图片工具类型（往顶部工具栏添加按钮）
    app.extension.registerElementTool({
      name: 'smartRemove',
      // label: '智能擦除新',
      icon: '',
    });

    app.extension.wrapElement('image', {
      overlayer: wrapImageOverlayer,
    });
  },
};
